var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCustomDota2Regular = function SvgCustomDota2Regular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "custom-dota2-regular_svg__cls-1",
    d: "M0 0v512h512V0H0Zm113.8 466.5-64-58.1 50.4-128 139.2 162.2c-4.9.8-125.6 23.9-125.6 23.9Zm352.2 2.7H355.9L33.3 98.2l72.3-72.9L466 346.6v122.6Zm-30-237.9L259.2 79.6c5.2-1.5 132.7-43.9 132.7-43.9l78.7 52.2L436 231.3Z"
  })));
};
export default SvgCustomDota2Regular;